import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-lg tracking-wide text-white">
                日韩影视大全
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注中文字幕日韩影视资源，涵盖日韩电影、电视剧、综艺全品类。海量高清中文字幕日韩内容，随时随地畅享原汁原味的日韩文化娱乐体验。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm">热门分类</h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm">快速链接</h3>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors">首页</Link></li>
              <li><Link to="/category/movie" className="text-sm text-foreground-300 hover:text-white transition-colors">日韩电影</Link></li>
              <li><Link to="/category/drama" className="text-sm text-foreground-300 hover:text-white transition-colors">日韩电视剧</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-300 hover:text-white transition-colors">日韩综艺</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm">联系我们</h3>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-base"></i>
                <span>{siteConfig.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-base"></i>
                <span>{siteConfig.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-base"></i>
                <span>{siteConfig.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 专注中文字幕日韩影视资源
          </p>
          <div className="flex items-center gap-4">
            <a href={siteConfig.social.weibo} target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-400 hover:text-white transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href={siteConfig.social.bilibili} target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-400 hover:text-white transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}